import { colors } from 'theme/theme';

export function highlightElement(element: HTMLElement) {
  const previousColor = element.style.backgroundColor;
  // eslint-disable-next-line no-param-reassign
  element.style.transition = 'background-color 0.5s ease';
  // eslint-disable-next-line no-param-reassign
  element.style.backgroundColor = colors.softBlue;

  setTimeout(() => {
    // eslint-disable-next-line no-param-reassign
    element.style.backgroundColor = previousColor;
  }, 1000);
}
